<h3 fxLayout="row" fxLayoutAlign="space-between center" mat-dialog-title>
    <div fxLayout="row" fxLayoutAlign="start center">
        @if (!showBidQuotes) {
        <command [command]="backCommand" attr.aria-label="Command-Back-{{Title}}-Purchasing"></command>
        }


        <div class="forge-typography--heading4">{{Title}}</div>
    </div>

    @if (canEdit) {
    <forge-icon-button (click)="addAction()">
        <forge-tooltip placement="bottom">{{PanelName}}</forge-tooltip>
        <forge-icon name="add"></forge-icon>
    </forge-icon-button>
    }
</h3>

<mat-dialog-content>
    @if (!isLoaded) {
    <busy-indicator [big]="true"></busy-indicator>
    }

    @if (isLoaded) {
    @if (showBidQuotes) {
    <bid-quotes [model]="bidQuotes" [canEdit]="canEdit" (delete)="deleteBidQuote($event)"
        (viewAttachments)="switchToAttachments($event)" (viewNotes)="switchToNotes($event)">
    </bid-quotes>
    }
    @if (showAttachments) {
    <attachments-container [canAdd]="canEdit" [canEdit]="canEdit" [model]="currentAttachments"
        (add)="appendAttachments($event)" (delete)="removeAttachment($event)">
    </attachments-container>
    }
    @if (showNotes) {
    <notes [model]="currentNotes" (delete)="deleteNote($event)" [viewOnly]="!canEdit">
    </notes>
    }
    <div class="error forge-typography--label1">
        @if (hasInvalidBidQuoteError) {
        <span>One or more bid/quotes are invalid.</span>
        }
        @if (hasInvalidNoteError) {
        <span>One or more notes are invalid.</span>
        }
        @if (hasInvalidAttachmentError) {
        <span>One or more attachments are invalid.</span>
        }
        @if (hasMultipleAwardedError) {
        <span>Only one bid/quote can be awarded.</span>
        }
    </div>
    }
</mat-dialog-content>

<mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
    <command-bar [commands]="dialogCommands" attr.telemetry="CmdBar-CommandKey-{{Title}}-Purchasing">
    </command-bar>
</mat-dialog-actions>